<template>
  <div id="corp-manning-vessel-list" class="h-full">
    <!-- 右上アクションボタン領域 -->

    <div class="aisea-text-18-600-dark-gray py-2">乗船期間一覧</div>
    <vs-divider :color="AISEA_COLOR.LIGHT_GRAY" class="mt-2 mb-0" />
    <div id="filter-select-area" class="flex flex-wrap py-2">
      <treeselect
        v-model="selectedFilterCrew"
        :options="filterCrewOptions"
        :multiple="true"
        placeholder="すべての船員"
        :limit="1"
        :limitText="count => `+${count}`"
        noOptionsText="なし"
        class="mr-4 my-1"
        @input="onFilterChanged"
        noResultsText="見つかりませんでした"
      ></treeselect>
      <treeselect
        v-model="selectedFilterVessel"
        :options="filterVesselOptions"
        :multiple="true"
        placeholder="すべての船舶"
        :limit="1"
        :limitText="count => `+${count}`"
        noOptionsText="なし"
        class="mr-4 my-1"
        @input="onFilterChanged"
        noResultsText="見つかりませんでした"
      ></treeselect>
      <treeselect
        v-model="selectedFilterRole"
        :options="filterRoleOptions"
        :multiple="true"
        placeholder="すべての職名"
        :limit="1"
        :limitText="count => `+${count}`"
        noOptionsText="なし"
        class="mr-4 my-1"
        @input="onFilterChanged"
        noResultsText="見つかりませんでした"
      ></treeselect>
      <treeselect
        v-model="selectedFilterStatus"
        :options="filterStatusOptions"
        :multiple="true"
        placeholder="すべてのステータス"
        :limit="1"
        :limitText="count => `+${count}`"
        noOptionsText="なし"
        class="mr-4 my-1"
        @input="onFilterChanged"
        noResultsText="見つかりませんでした"
      ></treeselect>
    </div>

    <vs-divider :color="AISEA_COLOR.LIGHT_GRAY" class="my-0" />

    <!-- AgGrid Table -->
    <ag-grid-vue
      :components="components"
      :gridOptions="gridOptions"
      @sortChanged="onSort"
      class="ag-theme-material w-full ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="tableData"
      domLayout="autoHeight"
      rowSelection="multiple"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="false"
      :suppressMovableColumns="true"
      :suppressPaginationPanel="true"
      :suppressDragLeaveHidesColumns="true"
      :suppressCellFocus="true"
      :suppressRowClickSelection="true"
      :suppressNoRowsOverlay="false"
    />

    <!-- ページネーション領域 -->
    <crew-pagination
      :currentPage="currentPage"
      :pageSize="pageSize"
      :totalElement="totalElement"
      @onChangePageSize="onChangePageSize"
      @onChangePage="onChangePage"
    ></crew-pagination>

    <vs-prompt
      :title="actionDialogTitle"
      :color="AISEA_COLOR.BLUE"
      buttons-hidden
      :active.sync="showActionDialog"
      class="corp-manning-vessel-list-add-dialog"
    >
      <div class="required-info-edit-form-container">
        <div class="mb-5">
          必要事項を入力してください。「<label></label>」は入力必須項目です。
        </div>

        <div class="flex items-center justify-between mb-5">
          <div>
            <label>期間</label>
            <div class="flex items-center fixed-width-item justify-between">
              <date-picker
                :value.sync="dialogStartDate"
                dateFormat="Y/m/d"
                placeholder="2022/01/01"
              ></date-picker>
              <div class="mx-3 h-fit">〜</div>
              <date-picker
                :value.sync="dialogEndDate"
                dateFormat="Y/m/d"
                placeholder="2022/02/01"
              ></date-picker>
            </div>
          </div>
        </div>

        <div class="form-item mb-5">
          <label class="form-item-title">
            {{ actionDialogVesselFormLabel }}
          </label>
          <div class="input-area fixed-width-item">
            <dropdown-select
              class="filter-input"
              :selectOptions="filteredVesselOptions"
              :selectedValue.sync="dialogSelectedVessel"
              placeholder="船名を選択してください"
              :border="true"
            ></dropdown-select>
          </div>
        </div>

        <label class="form-item-title mb-1">
          役職
        </label>
        <div class="form-scroll-area">
          <div class="option-form-area">
            <role-form-item
              class="option-form-item mb-2"
              v-for="(form, index) in mandatoryRoleFormItems"
              :roleOptions="roleOptions"
              :key="index"
              :deleteButton="false"
              :isDateSelectDisabled="true"
              :value.sync="mandatoryRoleFormItems[index]"
              :isApproverCheckboxDisabled="
                getApproverFixed(form ? form.role : null)
              "
              ref="mandatoryOption"
            >
            </role-form-item>

            <role-form-item
              class="option-form-item  mb-2"
              v-for="(form, index) in optionalRoleFormItems"
              :roleOptions="roleOptions"
              :key="index + 1 + '-' + optionalRoleFormItems.length"
              :deleteButton="true"
              :value.sync="optionalRoleFormItems[index]"
              :onClickDelete="() => deleteOptionalRoleFormItem(index)"
              :isApproverCheckboxDisabled="
                getApproverFixed(form ? form.role : null)
              "
            >
            </role-form-item>
            <add-button
              class="add-option-button my-5"
              :click="addRoleForm"
              title="役職を追加"
              icon="PlusIcon"
            ></add-button>
          </div>
        </div>
      </div>
      <span class="validation-label">{{ getDialogValidationMessage }}</span>
      <div class="flex w-full justify-end items-center">
        <div class="m-3 mb-0">
          <vs-button
            type="border"
            style="width: 6rem; padding: 0.4rem"
            @click="onActionDialogCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div class="m-3 mb-0">
          <vs-button
            :color="AISEA_COLOR.BLUE"
            style="width: 6rem; padding: 0.4rem"
            @click="
              () => {
                if (actionMode == 'edit') {
                  onEdit();
                } else if (actionMode == 'add') {
                  onAdd();
                } else if (actionMode == 'transfer') {
                  onTransfer();
                }
              }
            "
            :disabled="getDialogValidationMessage != null"
            >保存</vs-button
          >
        </div>
      </div>
    </vs-prompt>

    <vs-prompt
      title="船舶情報削除"
      type="confirm"
      :color="AISEA_COLOR.BLUE"
      accept-text="実行"
      cancel-text="キャンセル"
      :active.sync="showDeleteDialog"
      @accept="onDelete"
      @cancel="onDeleteCancel"
      class="corp-manning-vessel-list-delete-dialog"
    >
      <div>
        {{ dialogTargetPeriodLabel }}の船舶情報を削除しますか？<br />
        削除したデータは戻せません。
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import Vue from "vue";
import CellRendererVesselName from "./cell-renderer/CellRendererVesselName.vue";
import CellRendererRowActionButtons from "./cell-renderer/CellRendererRowActionButtons.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseManningCrewApi = AiseaApiFactory.get("enterpriseManningCrew");
const enterpriseCrewManningVesselApi = AiseaApiFactory.get(
  "enterpriseCrewManningVessel"
);
const enterpriseCrewRoleApi = AiseaApiFactory.get("enterpriseCrewRole");

import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DropdownSelect from "../components/DropdownSelect.vue";
import DatePicker from "../components/DatePicker.vue";
import RoleFormItem from "../components/RoleFormItem.vue";
import CrewPagination from "../components/CrewPagination.vue";
import AddButton from "../components/AddButton.vue";
import * as DateUtil from "@/utils/DateUtil.js";
import moment from "moment";

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererVesselName,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererRowActionButtons,
    Treeselect,
    DropdownSelect,
    DatePicker,
    RoleFormItem,
    CrewPagination,
    AddButton,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    activeSidebarCrew: Boolean,
    activeTab: Number,
  },
  data() {
    return {
      mandatoryRoleFormItems: [null],
      optionalRoleFormItems: [],

      tableData: [],

      showActionDialog: false,
      showDeleteDialog: false,

      actionMode: null, // edit or add or transfer
      actionDialogTitle: "",
      actionDialogVesselFormLabel: "",
      actionTargetCrewId: null,

      updatedCrewIds: [],

      pageable: {
        page: 0,
        total_elements: 0,
        total_pages: 1,
      },

      currentPage: 1,
      gridApi: null,
      gridOptions: {
        localeText: {
          noRowsToShow:
            '<div id="no-rows-manning-vessel-list" class="aisea-text-16-400-black">表示する乗船期間がありません</div>',
        },
        context: {
          componentParent: this,
        },
      },
      domLayout: "autoHeight",
      pageSize: 25,
      sortType: null,
      sortColumnKey: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        icons: {
          sortAscending:
            '<span class="material-icons">keyboard_arrow_up</span>',
          sortDescending:
            '<span class="material-icons">keyboard_arrow_down</span>',
          sortUnSort: '<span class="material-icons">unfold_more</span>',
        },
        unSortIcon: true,
        comparator: () => {
          return;
        },
      },
      columnDefs: [],
      components: {
        CellRendererVesselName,
        CellRendererRowActionButtons,
      },
      isReadyPagination: false,
      prevRoute: null,

      vesselOptions: [],
      dialogSelectedVessel: null,
      dialogStartDate: null,
      dialogEndDate: null,
      dialogTargetRowData: null,

      roleOptions: [],

      selectedFilterCrew: null,
      selectedFilterVessel: null,
      selectedFilterRole: null,
      selectedFilterStatus: [],

      filterCrewOptions: [],
      filterVesselOptions: [],
      filterRoleOptions: [],
      filterStatusOptions: [
        { id: 1, label: "乗船中" },
        { id: 2, label: "下船中" },
      ],
    };
  },
  async created() {
    this.initializeColumnDef();
    await this.fetchSearchOptions();
    await this.fetchRole();
    await this.fetchTableData();
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  watch: {
    currentPage() {
      this.fetchTableData();
    },
    dialogStartDate() {
      // 必須の役職の日付は乗船期間の開始日で固定する
      const newValue = this.mandatoryRoleFormItems[0]
        ? this.mandatoryRoleFormItems[0]
        : {};
      newValue.date = this.dialogStartDate;
      this.mandatoryRoleFormItems[0] = newValue;
    },
  },
  computed: {
    filteredVesselOptions() {
      if (this.actionMode == "transfer") {
        return this.vesselOptions.filter(vessel => {
          return vessel.value != this.dialogTargetRowData.vessel_id;
        });
      } else {
        return this.vesselOptions;
      }
    },
    getDialogValidationMessage() {
      if (
        !this.dialogStartDate ||
        !this.dialogEndDate ||
        !this.dialogSelectedVessel
      ) {
        return "入力されていない項目があります";
      }
      const combinedRoleFormItems = this.mandatoryRoleFormItems.concat(
        this.optionalRoleFormItems
      );
      for (let i = 0; i < combinedRoleFormItems.length; i++) {
        if (
          !combinedRoleFormItems[i] ||
          !combinedRoleFormItems[i].date ||
          !combinedRoleFormItems[i].role
        ) {
          return "入力されていない項目があります";
        }
      }
      for (let i = 0; i < combinedRoleFormItems.length - 1; i++) {
        if (
          !moment(combinedRoleFormItems[i + 1].date).isAfter(
            moment(combinedRoleFormItems[i].date)
          )
        ) {
          return "役職の日付は前の役職の日付よりも後になるようにしてください";
        }
      }
      if (
        moment(
          combinedRoleFormItems[combinedRoleFormItems.length - 1].date
        ).isAfter(moment(this.dialogEndDate))
      ) {
        return "役職の日付は乗船期間の終了日よりも前になるようにしてください";
      }
      return null;
    },

    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },

    totalElement() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },
    sortColumnList() {
      return this.columnDefs.map(x => x.field.toUpperCase());
    },
    roleList() {
      return this.crewRoles
        .map(role => {
          role.dispName = this.$t("Views.Crew." + role["localized_key"]);
          return role;
        })
        .filter(x => x.dispName);
    },
    dialogTargetPeriodLabel() {
      if (this.dialogTargetRowData != null) {
        return (
          this.dialogTargetRowData.daytime_in +
          "〜" +
          this.dialogTargetRowData.daytime_out
        );
      } else {
        return "";
      }
    },
  },
  methods: {
    initializeColumnDef() {
      const initialColumnDefs = [
        {
          headerName: "氏名",
          field: "name",
          minWidth: 200,
          flex: 1,
          cellRenderer: "CellRendererVesselName",
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "乗船日時",
          field: "daytime_in",
          minWidth: 140,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "下船日時",
          field: "daytime_out",
          minWidth: 140,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "船舶名",
          field: "vessel_name",
          minWidth: 160,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "役職名",
          field: "roleName",
          minWidth: 140,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "承認権限",
          field: "is_labor_admin",
          minWidth: 110,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "ステータス",
          field: "onboard",
          minWidth: 120,
          width: 120,
          sortable: false,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "最終更新日時",
          field: "updated_at",
          minWidth: 170,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },

        {
          headerName: "操作",
          field: "action",
          minWidth: 140,
          maxWidth: 140,
          cellRendererFramework: "CellRendererRowActionButtons",
          pinned: "right",
          resizable: false,
          sortable: false,
          cellRendererParams: {
            add: data => {
              this.setActionDialogAdd();
              this.actionTargetCrewId = data.id;
              this.showActionDialog = true;
            },
            edit: data => {
              this.setActionDialogEdit(data);
              this.actionTargetCrewId = data.id;
              this.showActionDialog = true;
            },
            delete: data => {
              this.setDeleteDialog(data);
              this.actionTargetCrewId = data.id;
              this.showDeleteDialog = true;
            },
            transfer: data => {
              this.setActionDialogTransfer(data);
              this.actionTargetCrewId = data.id;
              this.showActionDialog = true;
            },
          },
          cellStyle: params => this.customizeCellStyle(params),
        },
      ];

      this.columnDefs = initialColumnDefs;
    },
    onFilterChanged() {
      this.currentPage = 1;
      this.fetchTableData();
    },
    customizeCellStyle(params) {
      if (this.updatedCrewIds.includes(params.data.id)) {
        return { backgroundColor: "lightyellow" };
      } else {
        return null;
      }
    },
    getApproverFixed(roleId) {
      if (roleId === null || typeof roleId === "undefined") {
        return true;
      }
      const laborAdminType = this.roleOptions.find(el => el.value === roleId)
        .laborAdminType;
      return laborAdminType !== "VAR";
    },
    setActionDialogEdit(rowData) {
      this.dialogTargetRowData = rowData;

      const workPriodFrom = moment(
        this.dialogTargetRowData.daytime_in
      ).toDate();
      const workPriodTo = moment(this.dialogTargetRowData.daytime_out).toDate();
      this.dialogStartDate = workPriodFrom;
      this.dialogEndDate = workPriodTo;
      this.dialogSelectedVessel = this.dialogTargetRowData.vessel_id;
      const formRoleItem = this.dialogTargetRowData.roles.map(role => {
        return {
          role: role.id,
          date: moment(role.start_on).toDate(),
          is_labor_admin: role.labor_admin,
        };
      });
      const firstPart = formRoleItem.slice(0, 1);
      const secondPart = formRoleItem.slice(1);
      this.mandatoryRoleFormItems = firstPart;
      this.optionalRoleFormItems = secondPart;
      this.actionMode = "edit";
      this.actionDialogTitle = "乗船期間編集";
      this.actionDialogVesselFormLabel = "船名";
    },
    setActionDialogAdd() {
      this.clearDialogForm();
      this.actionMode = "add";
      this.actionDialogTitle = "乗船期間新規登録";
      this.actionDialogVesselFormLabel = "船名";
    },
    setActionDialogTransfer(rowData) {
      this.dialogTargetRowData = rowData;
      const workPriodFrom = moment().toDate();
      const workPriodTo = moment(this.dialogTargetRowData.daytime_out).toDate();
      this.dialogStartDate = workPriodFrom;
      this.dialogEndDate = workPriodTo;
      this.dialogSelectedVessel = null;
      const latestRole = this.dialogTargetRowData.roles[
        this.dialogTargetRowData.roles.length - 1
      ];

      this.mandatoryRoleFormItems = [
        {
          role: latestRole.id,
          date: moment().toDate(),
          is_labor_admin: latestRole.labor_admin
            ? latestRole.labor_admin
            : false,
        },
      ];
      this.optionalRoleFormItems = [];
      this.actionMode = "transfer";
      this.actionDialogTitle = "転船登録設定";
      this.actionDialogVesselFormLabel = "転船先船舶";
    },
    setDeleteDialog(rowData) {
      this.dialogTargetRowData = rowData;
    },
    deleteOptionalRoleFormItem(index) {
      this.optionalRoleFormItems.splice(index, 1);
    },

    clearDialogForm() {
      this.actionTargetCrewId = null;

      this.dialogStartDate = null;
      this.dialogEndDate = null;
      this.dialogSelectedVessel = null;
      this.mandatoryRoleFormItems = [null];
      this.optionalRoleFormItems = [];
    },
    onActionDialogCancel() {
      this.showActionDialog = false;
    },
    async onAdd() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const combinedRoleFormItems = this.mandatoryRoleFormItems.concat(
          this.optionalRoleFormItems
        );
        const roleList = combinedRoleFormItems.map(element => {
          return {
            enterprise_crew_role_id: element.role,
            is_labor_admin: element.is_labor_admin
              ? element.is_labor_admin
              : false,
            start_on: moment(element.date).format("YYYY-MM-DD"),
          };
        });

        const payload = {
          boarding_status: 0,
          daytime_in: moment(this.dialogStartDate).format("YYYY-MM-DD"),
          daytime_out: moment(this.dialogEndDate).format("YYYY-MM-DD"),
          enterprise_manning_vessel_crew_roles: roleList,
          enterprise_manning_vessel_id: this.dialogSelectedVessel,
          version: 0,
        };
        const enterpriseCrewId = this.actionTargetCrewId;
        const res = await enterpriseCrewManningVesselApi.add(
          enterpriseCrewId,
          payload
        );
        if (res.status == true) {
          this.updatedCrewIds.push(enterpriseCrewId);
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${this.dialogTargetPeriodLabel}の乗船期間を追加しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "乗船期間の追加に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchTableData();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    async onEdit() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const combinedRoleFormItems = this.mandatoryRoleFormItems.concat(
          this.optionalRoleFormItems
        );
        const roleList = combinedRoleFormItems.map(element => {
          return {
            enterprise_crew_role_id: element.role,
            is_labor_admin: element.is_labor_admin
              ? element.is_labor_admin
              : false,
            start_on: moment(element.date).format("YYYY-MM-DD"),
          };
        });

        const payload = {
          boarding_status: 0,
          daytime_in: moment(this.dialogStartDate).format("YYYY-MM-DD"),
          daytime_out: moment(this.dialogEndDate).format("YYYY-MM-DD"),
          enterprise_manning_vessel_crew_roles: roleList,
          enterprise_manning_vessel_id: this.dialogSelectedVessel,
          version: this.dialogTargetRowData.version,
        };
        const enterpriseCrewId = this.actionTargetCrewId;
        const enterpriseManningVesselCrewId = this.dialogTargetRowData
          .manning_vessel_crew_id;
        const res = await enterpriseCrewManningVesselApi.update(
          enterpriseCrewId,
          enterpriseManningVesselCrewId,
          payload
        );
        if (res.status == true) {
          this.updatedCrewIds.push(enterpriseCrewId);
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${this.dialogTargetPeriodLabel}の乗船期間を更新しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "乗船期間の更新に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchTableData();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    onDeleteCancel() {
      this.showDeleteDialog = false;
    },
    async onTransfer() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const combinedRoleFormItems = this.mandatoryRoleFormItems.concat(
          this.optionalRoleFormItems
        );
        const roleList = combinedRoleFormItems.map(element => {
          return {
            enterprise_crew_role_id: element.role,
            is_labor_admin: element.is_labor_admin
              ? element.is_labor_admin
              : false,
            start_on: moment(element.date).format("YYYY-MM-DD"),
          };
        });

        const payload = {
          boarding_status: 0,
          daytime_in: moment(this.dialogStartDate).format("YYYY-MM-DD"),
          daytime_out: moment(this.dialogEndDate).format("YYYY-MM-DD"),
          enterprise_manning_vessel_crew_roles: roleList,
          enterprise_manning_vessel_id: this.dialogSelectedVessel,
          version: this.dialogTargetRowData.version,
        };
        const enterpriseCrewId = this.actionTargetCrewId;
        const enterpriseManningVesselCrewId = this.dialogTargetRowData
          .manning_vessel_crew_id;
        const res = await enterpriseCrewManningVesselApi.transfer(
          enterpriseCrewId,
          enterpriseManningVesselCrewId,
          payload
        );
        if (res.status == true) {
          this.updatedCrewIds.push(enterpriseCrewId);
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${this.dialogTargetPeriodLabel}の乗船期間で転船しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "転船に失敗しました。",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchTableData();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    async onDelete() {
      this.showDeleteDialog = false;
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const payload = {
          enterprise_manning_vessel_id: this.dialogTargetRowData
            .manning_vessel_id,
        };
        const enterpriseCrewId = this.actionTargetCrewId;
        const enterpriseManningVesselCrewId = this.dialogTargetRowData
          .manning_vessel_crew_id;
        const res = await enterpriseCrewManningVesselApi.delete(
          enterpriseCrewId,
          enterpriseManningVesselCrewId,
          payload
        );

        if (res.status == true) {
          this.updatedCrewIds.push(enterpriseCrewId);
          this.$vs.notify({
            title: `船員乗船期間設定`,
            text: `${this.dialogTargetPeriodLabel}の乗船期間を削除しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "乗船期間の削除に失敗しました。",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchTableData();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    addRoleForm() {
      this.optionalRoleFormItems.push(null);
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },

    onSort(object) {
      let sortColumn = object.columnApi.columnModel.viewportColumns.find(
        element => {
          return element.sort != null;
        }
      );
      this.sortType = sortColumn ? sortColumn.sort.toUpperCase() : null;
      this.sortColumnKey = sortColumn ? sortColumn.colId.toUpperCase() : null;
      this.currentPage = 1;

      this.fetchTableData();
    },

    onChangePage(value) {
      this.currentPage = value;
    },

    onChangePageSize(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchTableData();
    },

    clearSearchQueryString() {
      this.searchQueryString = "";
    },

    async fetchSearchOptions() {
      const res = await enterpriseManningCrewApi.fetchSearchParameter();
      this.filterCrewOptions = res.data.crews.map(crew => {
        return {
          id: crew.id,
          label: crew.name,
        };
      });
      this.filterVesselOptions = res.data.vessels.map(vessel => {
        return {
          id: vessel.id,
          label: vessel.name,
        };
      });
      this.filterRoleOptions = res.data.roles.map(role => {
        return {
          id: role.id,
          label: role.name,
        };
      });

      this.vesselOptions = res.data.vessels.map(vessel => {
        return {
          text: vessel.name,
          value: vessel.id,
        };
      });
    },
    async fetchRole() {
      const res = await enterpriseCrewRoleApi.search();
      this.roleOptions = res.data.roles.map(element => {
        return {
          text: element.name,
          value: element.id,
          laborAdminType: element.labor_admin_type,
        };
      });
    },

    getFetchTableDataSearchQuery() {
      let query = {};
      query.now = DateUtil.toYMD(Date.now(), null);
      if (this.selectedFilterCrew) {
        query.crew_ids = this.selectedFilterCrew.join(",");
      }
      if (this.selectedFilterVessel) {
        query.vessel_ids = this.selectedFilterVessel.join(",");
      }
      if (this.selectedFilterRole) {
        query.role_ids = this.selectedFilterRole.join(",");
      }
      if (this.selectedFilterStatus.length > 0) {
        query.ashore = this.selectedFilterStatus.includes(2);
        query.on_board = this.selectedFilterStatus.includes(1);
      }
      query.size = this.pageSize;
      query.page = this.getCurrentPage();
      if (this.sortType && this.sortColumnKey) {
        query.sort_order = this.sortType;
        query.sort_column = this.sortColumnKey;
      }
      return query;
    },
    compareRoles(a, b) {
      /*
      下記の優先順位でソート
      1.現在の日付が start_on と end_on の間にある場合。
      2.現在の日付より後の start_on で、現在に最も近い日付。
      3.現在の日付より前の end_on で、現在に最も近い日付。
      */
      const now = new Date();
      const nowTime = now.getTime();

      const aStart = new Date(a.start_on).getTime();
      const aEnd = new Date(a.end_on).getTime();
      const bStart = new Date(b.start_on).getTime();
      const bEnd = new Date(b.end_on).getTime();

      // 現在時刻がstart_onとend_onの間にあるかチェック
      const aInRange = nowTime >= aStart && nowTime <= aEnd;
      const bInRange = nowTime >= bStart && nowTime <= bEnd;

      if (aInRange && !bInRange) return -1;
      if (!aInRange && bInRange) return 1;

      // 現在時刻に近いstart_onを見つける
      const aStartDiff = Math.abs(nowTime - aStart);
      const bStartDiff = Math.abs(nowTime - bStart);

      if (aStartDiff !== bStartDiff) return aStartDiff - bStartDiff;

      // 現在時刻に近いend_onを見つける
      const aEndDiff = Math.abs(nowTime - aEnd);
      const bEndDiff = Math.abs(nowTime - bEnd);

      return aEndDiff - bEndDiff;
    },
    async fetchTableData() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const query = this.getFetchTableDataSearchQuery();
        const res = await enterpriseManningCrewApi.fetchCrews(query);
        this.tableData = res.data.enterprise_crews.map(crew => {
          const firstCrew = crew.enterprise_manning_vessel_crew
            ? crew.enterprise_manning_vessel_crew[0]
            : null;
          if (firstCrew == null) {
            return {
              id: crew.id,
              name: crew.name,
              daytime_in: null,
              daytime_out: null,
              vessel_name: null,
              vessel_id: null,
              role: null,
              roles: null,
              is_labor_admin: null,
              picture: crew.picture,
              manning_vessel_crew_id: null,
              manning_vessel_id: null,
              onboard: null,
              updated_at: null,
              version: null,
              action_disabled_except_add: true,
            };
          }
          let roles = [...firstCrew.roles];
          roles.sort(this.compareRoles);
          return {
            id: crew.id,
            name: crew.name,
            daytime_in: moment(firstCrew.daytime_in).format("YYYY/MM/DD"),
            daytime_out: moment(firstCrew.daytime_out).format("YYYY/MM/DD"),
            vessel_name: firstCrew.vessel.name,
            vessel_id: firstCrew.vessel.id,
            roleName: roles[0].name,
            roles: firstCrew.roles,
            is_labor_admin: roles[0].labor_admin ? "あり" : "なし",
            picture: crew.picture,
            manning_vessel_crew_id: firstCrew.id,
            manning_vessel_id: firstCrew.vessel.id,
            onboard: firstCrew.onboard ? "乗船中" : "下船中",
            updated_at: moment(firstCrew.updated_at).format("YYYY/MM/DD HH:mm"),
            version: firstCrew.version,
            action_disabled_transfer: !firstCrew.onboard,
          };
        });
        Object.keys(res.data.pageable).forEach(key => {
          Vue.set(this.pageable, key, res.data.pageable[key]);
        });
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
      this.$emit("checkAlert");
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.corp-manning-vessel-list-add-dialog {
  .vs-dialog {
    max-width: 520px;
  }

  label {
    &:after {
      content: " *";
      font-size: 0.8rem;
      color: rgba(var(--vs-danger), 1);
    }
  }

  .validation-label {
    color: red;
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .fixed-width-item {
    width: 368px;
  }
}

#corp-manning-vessel-list {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-grid-table {
    height: 100%;

    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .ag-header-cell-text {
      font-family: $aisea-font-family;
      font-size: 12px;
      font-weight: 600;
    }

    .ag-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
    .ag-header-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .ag-header-cell {
    padding-right: 0;
  }
  .vs-tabs--content {
    padding: 4px 0 0 0;
  }

  .vs-pagination--ul {
    span {
      font-size: 12px;
      font-family: $aisea-font-family;
      font-weight: 400;
    }
  }
  .vue-treeselect__limit-tip-text {
    color: $aisea-blue !important;
  }

  .vue-treeselect--open .vue-treeselect__control {
    border-top-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__menu {
    box-shadow: 2px 5px 10px 0.5px #00000026;
    border-bottom-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__multi-value-item {
    color: $aisea-blue !important;
  }

  .vue-treeselect__control {
    width: 190px;
    height: 36px;
  }
}

.corp-manning-vessel-list-add-dialog {
  .form-scroll-area {
    //max-height: 340px;
    //overflow-y: scroll;
    .dropdown-select {
      min-width: 160px;
      max-width: 160px;
    }
    .add-option-button {
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
